import { Close } from '@atom-learning/icons'
import * as React from 'react'

import { styled } from '~/styled'

import { ActionIcon } from '../../action-icon/ActionIcon'
import { Icon } from '../../icon/Icon'
import { Banner } from '../Banner'
import { useBannerContext } from '../BannerContext'

const StyledDismiss = styled(
  ActionIcon,
  {
    base: [],
    variants: {
      emphasis: {
        bold: ['text-white!']
      },
      containerSize: {
        sm: ['absolute', 'right-4', 'top-4'],
        md: ['static']
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

type TBannerSlimDismissProps = Omit<
  React.ComponentProps<typeof StyledDismiss>,
  'children' | 'onClick' | 'href'
>

export const BannerSlimDismiss = ({
  label = 'dismiss',
  ...rest
}: TBannerSlimDismissProps): React.JSX.Element => {
  const { size, setHasDismiss, emphasis } = useBannerContext()

  React.useEffect(() => {
    setHasDismiss(true)
    return () => {
      setHasDismiss(false)
    }
  }, [setHasDismiss])

  return (
    <Banner.Dismiss asChild>
      <StyledDismiss
        label={label}
        size="md"
        hasTooltip={false}
        isRounded
        theme="neutral"
        containerSize={size}
        emphasis={emphasis as TBannerSlimDismissProps['emphasis']}
        {...rest}
      >
        <Icon is={Close} />
      </StyledDismiss>
    </Banner.Dismiss>
  )
}

BannerSlimDismiss.displayName = 'BannerSlimDismiss'
